import CCHeatmap from "../Common/CCHeatmap";
import {prepareBuffer} from "../../util/Buffer";

class ExampleHeatmap extends CCHeatmap {
    constructor(props) {
        super(props);

        this.state.fetchBackgroundOperation = false
    };

    componentDidMount() {
        super.componentDidMount();

        // Heatmap data shape: [xIndex, yIndex, value]
        const heatData = [];
        const xLabels = ['A', 'B', 'C', 'D', 'E'];
        const yLabels = ['Q1', 'Q2', 'Q3', 'Q4'];
        for (let x = 0; x < xLabels.length; x++) {
            for (let y = 0; y < yLabels.length; y++) {
                heatData.push([x, y, Math.round(Math.random() * 100)]);
            }
        }

        let series = structuredClone(this.props.Series ?? [{}]);
        series[0].data = heatData;

        let xAxis;
        if (this.state.xAxis === undefined) {
            xAxis = []
        } else {
            xAxis = structuredClone(this.state.xAxis);
        }
        if (xAxis.length === 0) {
            xAxis.push({ scaleType: 'band' })
        }
        xAxis[0].data = xLabels;

        let yAxis;
        if (this.state.yAxis === undefined) {
            yAxis = []
        } else {
            yAxis = structuredClone(this.state.yAxis);
        }
        if (yAxis.length === 0) {
            yAxis.push({ scaleType: 'band' })
        }
        yAxis[0].data = yLabels;

        this.setState({Loading: this.state.fetchBackgroundOperation, Series: series, xAxis: xAxis, yAxis: yAxis});

        this.applet.getEnterpriseComponent().executeQuery(1,100000);
    }

    enterpriseComponentLoadStarted = () => {
        this.setState({Loading: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let buffer = prepareBuffer(ec);

        let series = structuredClone(this.state.Series);
        if (series.length === 0) {
            series = [{data: []}]
        }
        series[0].data = []
        for (let i = 0; i < buffer.length; i++) {
            series[0].data.push([
                parseInt(buffer[i].get("X_AXIS")),
                parseInt(buffer[i].get("Y_AXIS_1")),
                parseInt(buffer[i].get("Y_AXIS_2")),
            ]);
        }

        this.setState({Loading: false, Series: series});
    };
}

export default ExampleHeatmap;
